/**
 * Determines whether a loan term is custom (non-standard) based on the term length and credit tier.
 * Standard terms are 36, 48, 60, and 72 months. Additionally, 84-month term with 'excellent' credit
 * is also considered standard.
 *
 * @param {number|string} term - The loan term in months
 * @param {string} selectedCreditTier - The credit tier of the borrower (e.g., 'excellent', 'verygood', etc.)
 * @returns {boolean} - Returns true if the term is custom (non-standard), false otherwise
 */
const isLoanTermCustom = (term, selectedCreditTier) => {
  const standardTerms = [36, 48, 60, 72];
  if (Number(term) === 84 && selectedCreditTier === 'excellent') {
    return false;
  }
  return !standardTerms.includes(Number(term));
};
export { isLoanTermCustom as default };
